var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"y-tree-table"},[_c('div',{staticClass:"y-tree-table__left"},[_c('y-tree')],1),_c('div',{staticClass:"y-tree-table__right"},[_c('y-table-pro',{attrs:{"load-data-api":_vm.loadDataApi,"columns":_vm.columns}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }